import { ActionButton, CloseModalButton } from '@library/components/buttons';
import { Modal } from '@library/components/modals/Modal';
import { Spinner } from '@library/components/Spinner';

export interface ConfirmationModalProps {
  children: React.ReactNode;
  confirmationCopy: string;
  handleConfirm: () => Promise<void> | void;
  isConfirmDisabled?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  label: string;
  onCancelModal: () => void;
}

export const ConfirmationModal = ({
  children,
  confirmationCopy,
  handleConfirm,
  isConfirmDisabled = false,
  isLoading = false,
  isOpen,
  label,
  onCancelModal
}: ConfirmationModalProps) => {
  // Modal button handlers to clear the input value and closes the modal for both
  // the confirm and cancel buttons

  return (
    <Modal isOpen={isOpen} className="z-[1000]" onCancelModal={onCancelModal}>
      <div className="bg-soFresh-110 border-soFresh-140 relative mx-auto w-[420px] flex-col rounded-md border">
        <div className="border-soFresh-140 flex h-16 items-center justify-between rounded-t border-b border-solid py-4 pl-6 pr-1">
          <p>{label}</p>
          <CloseModalButton handleOnClick={onCancelModal} />
        </div>
        <div className="text-soClean-180 flex flex-col p-6 text-sm">
          {children}
        </div>
        <div className="border-soFresh-140 flex justify-end gap-2 border-t border-solid px-6 py-4">
          {isLoading && <Spinner className="mr-1 mt-2.5" />}
          <ActionButton
            dataTestId="cancel-button"
            disabled={isLoading}
            handleOnClick={onCancelModal}
            title="Reset Changes"
            variant="secondary"
          >
            Cancel
          </ActionButton>
          <ActionButton
            dataTestId="primary-button"
            disabled={isConfirmDisabled}
            handleOnClick={handleConfirm}
            title="Confirm Changes"
            variant="primary"
          >
            {confirmationCopy}
          </ActionButton>
        </div>
      </div>
    </Modal>
  );
};
